import React from 'react'
import { patients } from '../clients/iron-fit'
import './Patient_Name.scss'
import moment from 'moment'

export const PatientNameWithIcon: React.FC<{ patientId: string, videoStatus?: string, microphoneStatus?: string, supportingPatientOnlineClassName?: string }> = ({ patientId, videoStatus, microphoneStatus, supportingPatientOnlineClassName = '' }) => {
  const [patient] = patients.usePatient(patientId)

  if (!patient) return null

  let isUnderAge = false

  const calculateAge = () => {
    const birthDate = moment(patient.dateOfBirth, 'DD-MM-YYYY')
    const today = moment()

    const years = today.diff(birthDate, 'years')
    birthDate.add(years, 'years')

    const months = today.diff(birthDate, 'months')
    birthDate.add(months, 'months')

    const days = today.diff(birthDate, 'days')

    const result = `${years} anos, ${months} meses e ${days} dias`
    if (years < 12) isUnderAge = true
    return result
  }

  return (
    <div className="patient-name-with-icon">
      <div className="d-flex">
        <div className="d-flex align-items-center">
          <i className={`fas fa-user mr-2 ${supportingPatientOnlineClassName}`} />
          <strong className={`text-truncate ${videoStatus && microphoneStatus ? 'fixedwidth' : ''}`} title={patient.name}>
            {patient.name}
          </strong>
        </div>
        {(videoStatus || microphoneStatus) && (
          <div className="d-flex">
            {videoStatus && (
              <div className="mr-2">
                {videoStatus === 'offline' && <i className="fas fa-video text-danger"></i>}
                {videoStatus === 'enabled' && <i className="fas fa-video text-success"></i>}
                {videoStatus === 'disabled' && <i className="fas fa-video-slash text-warning"></i>}
              </div>
            )}
            {microphoneStatus && (
              <div className="mr-2">
                {microphoneStatus === 'offline' && <i className="fas fa-microphone text-danger"></i>}
                {microphoneStatus === 'enabled' && <i className="fas fa-microphone text-success"></i>}
                {microphoneStatus === 'disabled' && <i className="fas fa-microphone-slash text-warning"></i>}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Date of Birth */}
      {patient.dateOfBirth && (
        <div className="d-flex align-items-center text-muted mt-1">
          <i className="fa-solid fa-cake-candles mr-2" />
          <small className={`dob-text ${isUnderAge ? 'isUnderAge' : ''}`}>{calculateAge()}</small>
        </div>
      )}

      {patient.corporationId && (
        <div className="d-flex align-items-center text-muted mt-2">
          <small className="text-truncate font-weight-600">{patient.corporationId}</small>
        </div>
      )}
    </div>
  )
}
